import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  settingsService,
  type EWallet,
  type CreateEWalletInput,
  type UpdateEWalletInput,
} from '@/services/settings.service';
import { settingsKeys } from '@/services/queryKeys';

export function useEWallets() {
  return useQuery<EWallet[]>({
    queryKey: settingsKeys.eWallets(),
    queryFn: () => settingsService.listEWallets(),
    retry: 0,
  });
}

export function useCreateEWallet() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: CreateEWalletInput) =>
      settingsService.createEWallet(body),
    onSuccess: () => qc.invalidateQueries({ queryKey: settingsKeys.eWallets() }),
  });
}

export function useUpdateEWallet() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id: string; body: UpdateEWalletInput }) =>
      settingsService.updateEWallet(id, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: settingsKeys.eWallets() }),
  });
}

export function useDeleteEWallet() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) =>
      settingsService.deleteEWallet(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: settingsKeys.eWallets() }),
  });
}

export function useSetDefaultEWallet() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) =>
      settingsService.setDefaultEWallet(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: settingsKeys.eWallets() }),
  });
}
